<script setup lang="ts">
  import { IconLoading } from '@gat-ship/icons'

  /** The in-flight row shown while a list step's options are loading. */
</script>

<template>
  <div class="text-muted-foreground flex items-center gap-2 py-3 text-sm">
    <IconLoading class="size-4 animate-spin" />
    Searching…
  </div>
</template>
